/**
 * CargaDestinatario
 * @author Simpli CLI generator
 */
import {$, ID, Resource, TAG} from 'simpli-web-sdk'
import {
  ResponseSerialize,
  ValidationEmail,
  ValidationMaxLength,
  ValidationPhone,
  ValidationRequired,
} from 'simpli-web-sdk'
import Endereco from '@/model/resource/Endereco'
import CargaDestinatarioSchema from '@/schema/CargaDestinatario.schema'
import {Exclude} from 'class-transformer'

export default class CargaDestinatario extends Resource {
  @Exclude()
  readonly $name: string = 'CargaDestinatario'

  @Exclude()
  readonly $endpoint: string = '/user/me/destinatario'

  get $schema() {
    return CargaDestinatarioSchema(this)
  }

  get $id() {
    return this.cpfCnpj
  }
  set $id(val: ID) {
    this.cpfCnpj = val as string
  }
  get $tag() {
    return this.nome
  }
  set $tag(val: TAG) {
    this.nome = val
  }

  @ResponseSerialize(Endereco)
  endereco = new Endereco()

  /**
   * Pode ser razão social
   */
  @ValidationRequired()
  @ValidationMaxLength(100)
  nome: string = ''

  @ValidationRequired()
  @ValidationMaxLength(255)
  cpfCnpj: string = ''

  @ValidationRequired()
  @ValidationMaxLength(255)
  @ValidationPhone()
  telefone: string = ''

  @ValidationMaxLength(255)
  indicadorIe: string | null = null

  @ValidationMaxLength(255)
  inscricaoEstadual: string | null = null

  @ValidationMaxLength(255)
  inscricaoSuframa: string | null = null

  @ValidationMaxLength(255)
  im: string | null = null

  @ValidationMaxLength(100)
  @ValidationEmail()
  email: string | null = null

  get idEnderecoFk() {
    if (!this.endereco) return 0
    return this.endereco.$id
  }
  set idEnderecoFk(idEnderecoFk: ID) {
    if (!this.endereco) this.endereco = new Endereco()
    this.endereco.$id = idEnderecoFk
  }

  translateColumn(column: string) {
    return $.t(`classes.${this.$name}.columns.${column}`)
  }

  async persistCargaDestinatario(model?: CargaDestinatario, spinner = 'persistCargaDestinatario') {
    const fetch = async () => {
      if (model) await model.validate()
      return await this.POST(`/user/carga-destinatario`, model)
    }

    return await $.await.run(fetch, spinner)
  }

  async getCargaDestinatario(id: number, spinner = 'getCargaDestinatario') {
    const fetch = async () => await this.GET(`/user/carga-destinatario/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
